import {useTranslation} from "next-i18next"
import React, {useContext, useState} from "react"
import Typography from "../reusable/Typography/Typography"
import Button from "../reusable/components/Button"
import {X} from "react-bootstrap-icons"
import {useRouter} from "next/router"
import Image from "next/image"
import LayoutContext from "../../context/LayoutContext"
import CheckoutContext from "../../context/CheckoutContext"
import FirebaseContext from "../../context/FirebaseContext"
import {Collections} from "../../firebaseAdmin/collections"
import {removeUndefined} from "../../utility/Helper"

type Props = {
  setModal: (onOff: boolean) => void,
  setInsuranceAdded: any,
  isCart?: boolean,
  totalPrice?: number
}

const AddInsurance: React.FC<Props> = ({setModal, setInsuranceAdded, isCart, totalPrice}) => {
	const {t} = useTranslation("insurance")
	const tCommon = useTranslation("common").t

	const router = useRouter()
	const {checkoutDocId} = router.query
	const [showSuccess, setShowSuccess] = useState(false)
	const [showFail, setShowFail] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const {isMobile} = useContext(LayoutContext)
	const [showButton, setShowButton] = useState(true)
	const {setData} = useContext(CheckoutContext)
	const {db} = useContext(FirebaseContext)

	const addInsurance = async (e: any) => {
		setIsLoading(true)
		e.preventDefault()

		if (!isCart) {
			try {
				const {doc, updateDoc} = await import("@firebase/firestore/lite")
				const checkoutDocRef = doc(db, Collections.checkOuts, checkoutDocId as string)
				await updateDoc(checkoutDocRef, removeUndefined({
					insuranceUpdated: true,
					insurance: true
				}))
				setShowSuccess(true)
				setIsLoading(false)
				setShowButton(false)
				setInsuranceAdded(true)
			} catch (e) {
				console.error(e)
				setShowFail(true)
				setIsLoading(false)
				setShowButton(true)
				setInsuranceAdded(false)
			}
		} else if (isCart) {
			setData(prevData => {
				return {
					...prevData,
					insurance: true,
					insurancePrice: totalPrice,
					activeStep: 3,
					insuranceFilled: true
				}
			})
			setShowSuccess(true)
			setIsLoading(false)
			setShowButton(false)
			setInsuranceAdded(true)
		} else {
			setShowFail(false)
			setIsLoading(false)
			setShowButton(false)
			setInsuranceAdded(true)
		}
	}

	return (
		<section className="bg-white container"
			style={{
				width: isMobile ? "90vw" : "528px"
			}}>
			<div className={"row g-0 justify-content-end"}>
				<div className={"col-auto"}>
					<div className={""}>
						<button type={"button"}
							className={"btn pt-4 px-0 pb-0 "}
							onClick={() => {
								setModal(false)
							}}>
							<X size={16}
								color={"#000000"}/>
						</button>
					</div>
				</div>
			</div>
			{showSuccess ?
				<>
					<div className="row g-0 align-items-center"
						style={{height: isMobile ? "auto" : "120px"}}>
						<div className="col-2">
							<Image src={"/assets/icons/success-bike-circle.svg"}
								width={48}
								height={48}/>
						</div>
						<div className="col-10 mt-3 text-success">
							<Typography variant="heading2"
								semanticTag="h2"
								className="mb-1">
								{t("Hurra!")}
							</Typography>
							<Typography variant="heading3"
								semanticTag="span">
								{t("success-text-insurance")}
							</Typography>
						</div>
					</div>
				</> : showFail ?
					<>
						<div className="row g-0 align-items-center"
							style={{height: isMobile ? "auto" : "120px"}}>
							{/* <div className="col-2">
								<Image src={"/assets/icons/success-bike-circle.svg"} width={48} height={48} />
							</div> */}
							<div className="col-10 mt-3">
								{/* <Typography variant="heading2" semanticTag="h2" className="mb-1">
									{t("Hurra!")}
								</Typography> */}
								<Typography variant="heading3"
									semanticTag="span">
									{t("fail-text-insurance")}
								</Typography>
							</div>
						</div>
					</> : <>
						<div className="row g-0 align-items-center"
							style={{height: isMobile ? "auto" : "120px"}}>
							<div className="col-12">
								<Typography variant="heading3"
									semanticTag="h3">
									{t("modal-title")}
								</Typography>
								<br/>
								<Typography variant="bodySm"
									semanticTag="h3">
									{t("modal-text-1")} <a href="/agb/calingo-agb.pdf"
										target="_blank"
										className="text-decoration-none border-yellow border-bottom text-dark text-bold">{tCommon("AGB")}</a>{t("modal-text-2")}
								</Typography>

								<br/>
							</div>
						</div>
					</>}
			<br/>
			<div className="pb-4">
				{showButton ? <div className="mb-3">
					<Button onClick={e => addInsurance(e)}
						color="#212529"
						textColor="#212529"
						bgColor="#FEC04D"
						className="w-100"
						label={t("button-confirmation")}
						isLoading={isLoading}
						spinnerColor={"white"}/>
				</div> : null}

				<Button onClick={() => {
					setModal(false)
				}}
				color="#fff"
				hoverColor="#212529"
				outline
				className="w-100"
				label={showButton ? t("text-button-remove") : t("button-close")}/>

			</div>
		</section>
	)
}

export default AddInsurance
